import { DataMapping } from "./data-mapping";
import { BotAuthentication } from "./bot-authentication";
import { TutorialBase } from "./tutorial-base";

export class Bot extends TutorialBase {
  public id: string;
  public name: string;
  public shortName: string;
  public description: string;
  public allowAnonymousAuthentication: boolean;
  public botServiceId: string;
  public sortOrderNumber: number;
  public inputFieldsMapping: DataMapping[];
  public outputFieldsMapping: DataMapping[];
  public jsonDeterminants: string;
  public formSchema: any = { components: [] };
  public hiddenInputFormFields: string;
  public hiddenOutputFormFields: string;
  public hiddenInputServiceFields: string;
  public hiddenOutputServiceFields: string;
  public category: string;
  public botSuccessMessage: string;
  public botFailMessage: string;
  public botType: string;
  public selectedPrint: string;
  public selectedFileUploadComponentKey: string;
  public selectedMessage: string;
  public selectedReceiver: string;
  public sendAlert: boolean = false;
  public botAuthentication: BotAuthentication;
  public latestBotServiceId: boolean;
  public latestBotService: any;
  public currentBotService: string;
  public counterActions: any = [];
  public counterRoles: any = [];
  public inputFieldsFilter: any;
  public outputFieldsFilter: any;
  public inputQueryFilter: any;
  public businessKey: string;
  public selectedChannel: string = "EMAIL";
  public redirectUrl: string;
  public externalTarget: boolean = true;
  public isEregistrationService: boolean = false;
}
